/* -------------------------------------------------------------------------- */
/*                                 Schema Workmanships                          */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const workmanship = new schema.Entity('workmanships', {}, { idAttribute: 'workmanshipId' });
export const workmanships = new schema.Array(workmanship);
